// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"first-time-beta-modal__checkbox___1fheq","checkbox-text":"first-time-beta-modal__checkbox-text___NZJwt","actions":"first-time-beta-modal__actions___1EH1D"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/first-time-beta-modal.scss
// module id = 1335
// module chunks = 0